import { useState } from 'react';

export const useSignatureModal = () => {
    const [isSignatureModalVisible, setIsSignatureModalVisible] = useState(false);

    const showSignatureModal = (e) => {
        if (e) e.preventDefault();
        setIsSignatureModalVisible(true);
    };

    const hideSignatureModal = () => {
        setIsSignatureModalVisible(false);
    };

    return {
        isSignatureModalVisible,
        showSignatureModal,
        hideSignatureModal,
    };
};